var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
var SvgSummary = function SvgSummary(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 26,
    fill: "none",
    viewBox: "0 0 28 26"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFC500",
    clipPath: "url(#summary_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M19.587 5.085a.85.85 0 0 0-.472-1.45l-2.565-.373a.85.85 0 0 1-.64-.466L14.763.473a.85.85 0 0 0-1.526 0L12.09 2.796a.85.85 0 0 1-.64.466l-2.565.372a.85.85 0 0 0-.472 1.45l1.856 1.81a.85.85 0 0 1 .245.752l-.438 2.553a.85.85 0 0 0 1.234.896l2.295-1.205a.85.85 0 0 1 .79 0l2.295 1.205a.85.85 0 0 0 1.234-.896l-.437-2.553a.85.85 0 0 1 .244-.753zM1.82 15.393h6.647c.39 0 .706.316.706.705v7.691H1.114v-7.69c0-.39.317-.706.706-.706M10.677 12.594h6.647c.39 0 .705.316.705.706v10.489H9.971v-10.49c0-.39.316-.705.705-.705zM19.533 18.192h6.646c.39 0 .706.316.706.705v4.892h-8.058v-4.892c0-.39.316-.705.705-.705M27.3 26H.7a.7.7 0 0 1 0-1.4h26.6a.7.7 0 0 1 0 1.4"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "summary_svg__a"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h28v26H0z"
  })))));
};
export default SvgSummary;